import * as React from 'react'

import { Box, Button, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'
import { PerformanceReviewsEvaluationAgreement } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

import AgreeEvaluationModal from '../Modals/AgreeEvaluationModal'
import DisagreeEvaluationModal from '../Modals/DisagreeEvaluationModal'

interface Props {
  questionGroup: QuestionGroup
  agreement: NonNullable<PerformanceReviewsEvaluationAgreement>
  canEditAgreement: boolean
}

const TargetDisagreeEvaluation = ({ questionGroup, agreement, canEditAgreement }: Props) => {
  const [agreementModalOpen, toggleAgreementModal] = useToggle(false)
  const [disagreementModalOpen, toggleDisgreementModal] = useToggle(false)
  const date = dateBackendDateTimeToUI(agreement.submittedAt)

  const onClickAgree = () => {
    toggleAgreementModal(!agreementModalOpen)()
  }

  const onClickDisagree = () => {
    toggleDisgreementModal(!disagreementModalOpen)()
  }

  return (
    <>
      <Box
        gap="s32"
        background="radicalRed100"
        padding="s16"
        height="full"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'radicalRed400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        <>
          <Box flexDirection="row" gap="s32" alignItems="center" justifyContent="spaceBetween">
            <Box flexDirection="row" gap="s8">
              <Icon.Medium icon="thumbs-down" color="radicalRed1200" />
              <Text.Normal color="grey1000">
                {canEditAgreement
                  ? i18n.t('surveys.review.reviews.agreements_section.target_user.disagreement', {
                      agreement_decision_date: date,
                    })
                  : i18n.t(
                      'surveys.review.reviews.agreements_section.respondent_user.target_disagreed',
                      {
                        target_user_name: questionGroup.target.firstName(),
                        agreement_decision_date: date,
                      }
                    )}
              </Text.Normal>
            </Box>
            {canEditAgreement ? (
              <Box flexDirection="row" gap="s16">
                <Button type="secondary" onClick={onClickAgree}>
                  {i18n.t('surveys.review.reviews.agreements_section.target_user.change_to_agree')}
                </Button>
                <Button type="secondary" onClick={onClickDisagree} iconName="file-filled" />
              </Box>
            ) : (
              <Box flexDirection="row" gap="s16">
                <Button type="secondary" onClick={onClickDisagree} iconName="file-filled" />
              </Box>
            )}
          </Box>
        </>
      </Box>
      {disagreementModalOpen && (
        <DisagreeEvaluationModal
          evaluationId={questionGroup.id}
          agreement={agreement}
          canEditAgreement={canEditAgreement}
          onClose={toggleDisgreementModal(false)}
        />
      )}
      {agreementModalOpen && (
        <AgreeEvaluationModal
          evaluationId={questionGroup.id}
          onClose={toggleAgreementModal(false)}
        />
      )}
    </>
  )
}

export default observer(TargetDisagreeEvaluation)
